import React, { useEffect, useState } from "react";
import { Box, Typography, alpha } from "@mui/material";
import { FaClock } from "react-icons/fa";
import { COLORS } from "../../../styles/uiConstants";
import useTerms from "../../../hooks/useTerms";

function format(ms) {
  const totalSec = Math.max(0, Math.floor(ms / 1000));
  const h = Math.floor(totalSec / 3600);
  const m = Math.floor((totalSec % 3600) / 60);
  const s = totalSec % 60;
  return `${h}sa ${m}dk ${s}s`;
}

export default function DurationTimer({ startedAt, frozenMs = null }) {
  const terms = useTerms();
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    if (frozenMs != null) return;
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, [frozenMs]);

  const ms =
    frozenMs != null
      ? frozenMs
      : startedAt
        ? now - new Date(startedAt).getTime()
        : 0;

  const isFrozen = frozenMs != null;

  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 1,
        px: 1.5,
        py: 0.75,
        borderRadius: 2,
        bgcolor: isFrozen ? COLORS.successLight : COLORS.slate50,
        border: `1px solid ${isFrozen ? alpha(COLORS.success, 0.35) : COLORS.slate200}`,
      }}
      title={isFrozen ? `${terms.exam} süresi` : `${terms.exam} süresi (devam ediyor)`}
    >
      {isFrozen ? (
        <FaClock size={13} color={COLORS.successDarker} />
      ) : (
        <Box
          component="span"
          sx={{
            width: 8,
            height: 8,
            borderRadius: "50%",
            bgcolor: COLORS.success,
            "@keyframes timerPulse": {
              "0%": { boxShadow: `0 0 0 0 ${alpha(COLORS.success, 0.5)}` },
              "70%": { boxShadow: `0 0 0 6px ${alpha(COLORS.success, 0)}` },
              "100%": { boxShadow: `0 0 0 0 ${alpha(COLORS.success, 0)}` },
            },
            animation: "timerPulse 2s infinite",
          }}
        />
      )}
      <Typography
        sx={{
          fontSize: "0.875rem",
          fontWeight: 600,
          color: isFrozen ? COLORS.successDarker : COLORS.slate700,
          fontVariantNumeric: "tabular-nums",
          minWidth: 90,
        }}
      >
        {format(ms)}
      </Typography>
    </Box>
  );
}
